<script>
import {Vuetable} from './../vuetable-2'
import KSPagination from './KSPagination.vue'
import KSPaginationInfo from './KSPaginationInfo.vue'
import CssConfig from './KSTableCss'
import CellContextFilter from './component/cell-context-filter.vue'
import KeyMetaData from './component/key-meta.vue'
import axios from 'axios'
import Api from 'keysso/api/api'
import clipboard from 'clipboard-polyfill'
import DomainHistoryByKeywords from './component/domain-history-by-keys.vue'
import HasAnotherResults from "../common/HasAnotherResults.vue";
import clone from 'lodash/clone'

import {get} from 'lodash';

import moment from 'moment';
import KsRsyAd from "../common/KsRsyAd.vue";
import KsImg from "../common/KsImg.vue";
import AllRsyAdsContainer from "../rsy-ads/AllRsyAdsContainer.vue";
import Engine from "../../mixins/Engine";
import {Zen} from "../../constants/zen";
import RsyAdImgContainer from "../rsy-ads/RsyAdImgContainer.vue";
import {nextTick} from "vue";
import AdaptersDialog from "../adapters/Dialog.vue";
import {Listeners} from "../../constants/listeners";
import CsvExportJob from "../../mixins/CsvExportJob";
import KSTablePopoverArrayRows from "./component/popover-array-rows.vue";
import AdaptersOverlayPanel from "../adapters/OverlayPanel.vue";
import ReportKeywordBudget from "keysso/page/report/component/KeywordBudget.vue";
import DataTable from "primevue/datatable";
import Button from "primevue/button";
import {FormatHelper} from "../../helpers/FormatHelper";
import {HtmlHelper} from "../../helpers/HtmlHelper";
import {FilterHelper} from "../../helpers/FilterHelper";
import {FilterConstants} from "keysso/constants/filterConstants";
import Alerts from 'keysso/mixins/Alerts';
import {StorageKeys} from 'keysso/constants/storageKeys';
import BrowserStorage from 'keysso/mixins/BrowserStorage';

moment.locale(window.locale ?? 'ru');

export default {
    components: {
        AdaptersOverlayPanel,
        RsyAdImgContainer,
        AllRsyAdsContainer,
        KsImg,
        KsRsyAd,
        Vuetable,
        'ks-pagination': KSPagination,
        'ks-pagination-info': KSPaginationInfo,
        CellContextFilter,
        DomainHistoryByKeywords,
        KeyMetaData,
        AdaptersDialog,
        HasAnotherResults,
        KSTablePopoverArrayRows,
        ReportKeywordBudget,
        DataTable,
        Button,
    },
    mixins: [Engine, Alerts, BrowserStorage, CsvExportJob],
    data() {
        return {
            css: CssConfig,
            loading: false,
            dataExist: false,
            isFirstLoad: true,
            infoTemplate: null,
            noDataTemplate: null,
            message: null,
            error: null,
            contextCell: null,
            selectedTo: [],

            /**
             * Информационное сообщение со схлопыванием
             */
            messageCollapse: null,
            showMessageCollapse: false,

            isDemo: false,
            isAuthorized: false,
            isRestrictions: false,
            /*isPhoneConfirmed: false,*/
            isPayed: false,
            needleTariff: 0,
            demoLimit: 10,
            total: 0,
            isFilter: true,
            isSort: true,

            tPerPage: null,
            tInitialPage: null,

            locale: window.locale,
            demoTariffModal: {
              show: false,
              message: "",
            },
            dialogDemoTariffListenerId: Listeners.POPUP_KS_TABLE_DEMO_OPEN,
            dialogRestrictionsListenerId: Listeners.KS_TABLE_SHOW_RESTRICTIONS_DIALOG,
            localPostData: null,
            frozenHeadRafId: null,
            isFrozenHeadActive: false,
            frozenHeadActivationThreshold: 10,
        }
    },
    props: {
        isAllRsyAds: {
            type: Boolean,
            required: false,
            default: false
        },
        apiUrl: {
            type: String,
            required: true
        },
        fields: {
            type: Array,
            required: true
        },
        sortOrder: {
            type: Array,
            default() {
                return []
            }
        },
        enabledContextMenu: {
            type: Boolean,
            required: false,
            default() {
                return true
            }
        },
        enabledAnimate: {
            type: Boolean,
            required: false,
            default() {
                return true
            }
        },
        perPage: {
            type: Number,
            default() {
                return 25
            }
        },
        initialPage: {
            type: Number,
            default() {
                return 1
            }
        },
        appendParams: {
            type: Object,
            default() {
                return {}
            }
        },
        domainUrl: {
            type: String,
            required: false
        },
        pageUrl: {
            type: String,
            required: false
        },
        domainId: {
            type: String,
            required: false
        },
        onRowClicked: {
            type: Function,
            required: false,
            default() {
                return () => {
                }
            }
        },
        saveState: {
            type: Boolean,
            required: false,
            default() {
                return false
            }
        },

        showPaginationTop: {
            type: Boolean,
            required: false,
            default() {
                return false
            }
        },
        exportCsvUrl: {
            type: String,
            required: false
        },
        // Выгрузка строится воркером: запрос возвращает job_id, файл забираем по готовности.
        useAsyncCsvExport: {
            type: Boolean,
            required: false,
            default: true
        },
        // Общая ручка статуса; у отчётов со своей очередью она своя.
        exportStatusUrl: {
            type: String,
            required: false,
            default: '/report/export-status'
        },
        copyUrl: {
            type: String,
            required: false
        },
        isPost: {
            type: Boolean,
            required: false,
            default: false
        },
        postData: {
            type: String,
            required: false,
            default: null,
        },
        // оставить кнопки < и > убрав лишнее
        simplePagination: {
            type: Boolean,
            required: false,
            default: false
        },
        // фиксация заголовка таблицы при прокрутке страницы
        frozenHead: {
            type: Boolean,
            required: false,
            default: true,
        },
        /**
         * Условие фильтра, без которого API отчёта отвечает 400 (например 'status=1').
         * В режиме ограничений такой фильтр пропускается в запрос без апселл-диалога:
         * бэкенд его разрешает, см. AVAILABLE_FILTERS_ON_DEMO_MODE
         * в api/Middleware/LinksDemoFilters.php
         */
        requiredFilter: {
            type: String,
            required: false,
            default: ''
        }
    },
    created() {

        this.infoTemplate = this.$tm('lang.main.table.info_template');
        this.noDataTemplate = this.$tm('lang.main.table.no_data_template');

        const reportDemoMode = window.report_is_demo === true || window.is_user_payed === false;
        if (reportDemoMode) {
            this.isRestrictions = true;
            // ответ API демо-отчёта не содержит этих флагов, берём из страницы
            this.isAuthorized = window.is_user_auth === true;
            this.isPayed = window.is_user_payed === true;
        }

        if (this.isRestrictions) {
            // в режиме ограничений используем значение по умолчанию
            this.tPerPage = this.perPage;
        } else {
            // в остальных случаях используем значение из локального хранилища
            this.tPerPage = this.getLocalStorageItem(StorageKeys.GLOBAL_TABLE_PER_PAGE) ?? this.perPage;
        }

        this.tInitialPage = this.initialPage;

        this.localPostData = this.postData;

        if (window.location.hash !== "") {

            let self = this;
            const hashs = window.location.hash.slice(window.location.hash.indexOf('#') + 1).split('&');

            hashs.forEach((h) => {
                const hash = h.split("=");
                if (hash.length === 2) {

                    switch (hash[0]) {
                        case "page":
                            self.tInitialPage = parseInt(hash[1]);
                            break;
                        case "per_page":
                            self.tPerPage = parseInt(hash[1]);
                            break;
                        case "filter":
                            self.onFilterSet(decodeURIComponent(hash[1]), false);
                            break;
                        case "forDay":
                            this.onForDaySet(hash[1], false)
                            break;
                        case "sort":
                            if (hash[1]) {
                                self.sortOrder.splice(0, self.sortOrder.length);
                                let sorts = decodeURIComponent(hash[1]).split(",");

                                sorts.forEach((sort) => {

                                    let s = sort.split("|");
                                    if (s.length == 2) {

                                        let field = self.fields.filter(f => f.sortField === s[0] && f.sortable !== false);

                                        if (field.length) {

                                            self.sortOrder.push({
                                                field: field[0].name,
                                                sortField: field[0].sortField,
                                                direction: s[1]
                                            });

                                        }

                                    }

                                });

                            }

                            break;
                    }

                }

            });

        }

        if (reportDemoMode) {
            this.tInitialPage = 1;
            this.tPerPage = this.perPage;
        }

    },
    mounted() {
        if (this.useAsyncCsvExport) {
            // выгрузка могла быть запущена до перезагрузки страницы
            this.resumeCsvExportIfNeeded();
        }

        this.$emitter.on(Listeners.KS_FILTER_SET, eventData => this.onFilterSet(eventData, true));
        this.$emitter.on(Listeners.KS_FILTER_SET_FOR_DAY, data => this.onForDaySet(data, true));
        this.$emitter.on(Listeners.KS_FILTER_RESET, e => this.onFilterReset());
        this.$emitter.on(Listeners.KS_DELETE_FILTER_PARAMS, e => this.deleteParams());
        this.$emitter.on(Listeners.KS_FILTER_REFRESH, this.refresh);
        this.$emitter.on(Listeners.KS_TABLE_DO_LOAD, this.refresh)
        this.$emitter.on(Listeners.KS_TABLE_NORMALIZE_FIELDS, e => this.normalizeFields());
        this.$emitter.on(Listeners.KS_TABLE_DOWNLOAD, eventData => this.download(eventData));
        this.$emitter.on(Listeners.KS_TABLE_DOWNLOAD_IMAGES, eventData => this.downloadImages(eventData));
        this.$emitter.on(Listeners.KS_TABLE_COPY, this.copy);
        this.$emitter.on(Listeners.KS_TABLE_CLEAR_SELECTED_TO, this.clearSelectedTo);
        this.$emitter.on(Listeners.CLUSTER_DRAG_START_KEYS, targetDragKeyId => this.onClusterDragStart(targetDragKeyId));

        let vuetable = this.$refs.vuetable;
        vuetable.singleColumnSort = (field) => {

            if (vuetable.sortOrder.length === 0) {
                vuetable.clearSortOrder()
            }

            vuetable.sortOrder.splice(1);

            if (vuetable.fieldIsInSortOrderPosition(field, 0)) {
                vuetable.sortOrder[0].direction = vuetable.sortOrder[0].direction === 'asc' ? 'desc' : 'asc'
            } else {
                vuetable.sortOrder[0].direction = 'desc'
            }
            vuetable.sortOrder[0].field = field.name;
            vuetable.sortOrder[0].sortField = field.sortField;

        }

        if (this.frozenHead) {
            // Держим fixed-клон шапки в sync при любом скролле и resize.
            window.addEventListener('scroll', this.scheduleFrozenHeadSync, { passive: true });
            window.addEventListener('resize', this.scheduleFrozenHeadSync, { passive: true });
            this.getTableWrapperEl()?.addEventListener('scroll', this.scheduleFrozenHeadSync, { passive: true });
            nextTick(this.scheduleFrozenHeadSync);
        }

    },
    updated() {
        if (this.frozenHead) {
            nextTick(this.scheduleFrozenHeadSync);
        }
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.scheduleFrozenHeadSync);
        window.removeEventListener('resize', this.scheduleFrozenHeadSync);
        this.getTableWrapperEl()?.removeEventListener('scroll', this.scheduleFrozenHeadSync);
        this.resetFrozenHeadStyles();

        if (this.frozenHeadRafId) {
            cancelAnimationFrame(this.frozenHeadRafId);
            this.frozenHeadRafId = null;
        }
    },
    computed: {
        FormatHelper() {
            return FormatHelper
        },
        getFields() {
            let self = this;
            return this.fields.map((f) => {
                if (f.hasOwnProperty('title') && f.hasOwnProperty('description')) {
                    if (self.domainUrl) {
                        f.title = `<span title="${f.description.replace('{domain}', self.domainUrl || "")}">${f.title}</span>`;
                        f.description = f.description.replace('{domain}', self.domainUrl || "");
                    } else if (self.pageUrl) {
                        f.title = `<span title="${f.description.replace('{page}', self.pageUrl || "")}">${f.title}</span>`;
                        f.description = f.description.replace('{page}', self.pageUrl || "");
                    } else {
                        f.title = `<span title="${f.description}">${f.title}</span>`;
                    }
                }

                // Без сортировки (ограничения тарифа или sortable: false) — sortField удаляем у копии:
                // исходные поля общие с ks-filter, и там sortField — имя поля в фильтре
                if ((self.isRestrictions && !self.isSort) || f.sortable === false) {
                    f = {...f};
                    delete f.sortField;
                }

                return f;
            });
        },
        getApiUrl() {
            return this.$config.API_URL + this.apiUrl;
        },
        getApiExportUrl() {
            return this.$config.API_URL + this.exportCsvUrl
        },
        apiCsvExportStatusUrl() {
            return this.$config.API_URL + this.exportStatusUrl
        },
        getApiCopyUrl() {
            return this.$config.API_URL + this.copyUrl
        },
        getDataForPost() {
            return this.localPostData ? JSON.parse(this.localPostData) : null;
        },
        showPagination() {
            return !this.isRestrictions && this.dataExist
        },
        getRestrictionDialogAgreeButtonTitle() {
            return !this.isAuthorized
                ? this.$t('lang.modal.register')
                : (!this.isPayed ? this.$t('lang.modal.buy_tariff') : this.$t('lang.promo_tariff.change_plan'));
        }
    },
    methods: {
        isGetUrlLengthAllowed(filterText) {
            const requestUrl = new URL(this.getApiUrl, window.location.origin);
            const queryParams = {
                ...(this.appendParams || {}),
                filter: filterText,
            };

            Object.keys(queryParams).forEach((paramName) => {
                const paramValue = queryParams[paramName];
                if (paramValue === undefined || paramValue === null || paramValue === '') {
                    requestUrl.searchParams.delete(paramName);
                    return;
                }

                requestUrl.searchParams.set(paramName, paramValue);
            });

            return requestUrl.toString().length <= FilterConstants.MAX_GET_URL_LENGTH;
        },
        onClusterDragStart(targetDragKeyId) {
            if (this.selectedTo.includes(targetDragKeyId)) {
                return;
            }

            let self = this;
            nextTick(() => {
                self.selectedTo.push(targetDragKeyId);
                if (!self.$refs.vuetable) {
                    return;
                }

                self.$refs.vuetable.selectId(targetDragKeyId);
            });
        },
        get,
        transform(data) {
            let self = this;
            data.from = data.current_page === 1 ? 1 : (data.current_page * data.per_page - data.per_page + 1);
            data.to = (data.current_page * data.per_page) > data.total ? data.total : (data.current_page * data.per_page);

            if (data.hasOwnProperty('demo')) {
                this.isDemo = data.demo;
                this.isRestrictions = data.restrictions;
                this.isAuthorized = data.authorized;
                this.isPayed = data.payed;
                this.needleTariff = data.needleTariff;
                this.demoLimit = data.demoLimit;
                this.isFilter = data.isFilter;
                this.isSort = data.isSort;
                this.total = data.total;

                nextTick(() => {
                    if (!self.isSort) {
                        self.normalizeFields();
                    }
                });

            }

            if (data.hasOwnProperty('message')) {
                this.message = data.message;
            } else {
                this.message = null
            }

            if (data.hasOwnProperty('messageCollapse')) {
                this.messageCollapse = data.messageCollapse;
            }

            this.dataExist = data.hasOwnProperty('data');

            if (data.hasOwnProperty('demoTariff') || (this.isDemo && this.isRestrictions)) {
              this.demoTariffModal.show = true
            }

            return data;
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);

            if (this.showPaginationTop) {

                this.$refs.paginationTop.setPaginationData(paginationData);
                this.$refs.paginationInfoTop.setPaginationData(paginationData);

            }

            // Автоскролл оставляем только для сценария с верхней пагинацией.
            // Иначе при переключении страниц получается резкий "прыжок" вверх.
            if (!this.isFirstLoad && this.enabledAnimate && this.showPaginationTop) {
                this.scrollToTableContentTop();
            }
            this.isFirstLoad = false;
        },
        scrollToTableContentTop() {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    const tableEl = this.getTableEl();
                    const firstRowEl = tableEl?.querySelector('tbody tr');
                    const anchorEl = firstRowEl || tableEl;
                    if (!anchorEl) {
                        return;
                    }

                    const topMenuOffset = this.getTopMenuHeight();
                    const frozenHeadOffset = this.frozenHead
                        ? (this.$refs.frozenHeadOverlay?.getBoundingClientRect().height || this.getTheadEl()?.getBoundingClientRect().height || 0)
                        : 0;
                    const targetTop = window.scrollY + anchorEl.getBoundingClientRect().top - topMenuOffset - frozenHeadOffset;

                    window.scrollTo({
                        top: Math.max(0, targetTop),
                        behavior: 'smooth',
                    });
                });
            });
        },
        normalizeFields() {
            this.$refs.vuetable.normalizeFields();
        },
        onChangePage(page) {
            if (this.isRestrictions) {
                this.$emitter.emit(this.dialogRestrictionsListenerId);
                return false;
            }
            this.$refs.vuetable.changePage(page);
        },
        onChangePerPage(value) {
            if (this.isRestrictions) {
                this.$emitter.emit(this.dialogRestrictionsListenerId);
                return false;
            }

            this.tPerPage = parseInt(value);
            this.setLocalStorageItem(StorageKeys.GLOBAL_TABLE_PER_PAGE, this.tPerPage);

            let self = this;
            nextTick(() => self.$refs.vuetable.refresh());
        },

        onTableInitialized() {
        },

        onTableLoading() {
            this.error = null;
            this.loading = true;
            // Во время запроса скрываем фиксированную копию шапки,
            // чтобы она не перекрывала строки после обновления данных.
            this.resetFrozenHeadStyles();
        },
        onTableLoaded() {
            this.loading = false;

            if (this.saveState) {

                let params = this.$refs.vuetable.getAppendParams(this.$refs.vuetable.getAllQueryParams()),
                    parts = [];

                for (var prop in params) {
                    parts.push(this.encode(prop) + '=' + this.encode(params[prop]));
                }

                history.replaceState({}, "filter", "#" + parts.join('&'));

            }

            // Уведомляем о загрузке данных таблицы после того, как данные установлены
            // Используем nextTick чтобы гарантировать, что tableData обновлен
            const self = this;
            nextTick(() => {
                const tableData = self.$refs.vuetable?.tableData;
                if (tableData && Array.isArray(tableData)) {
                    self.$emitter.emit(Listeners.KS_TABLE_DATA_LOADED, {
                        tableData: tableData,
                        table: self
                    });
                }
            });


        },
        onTableLoadError(res) {
            this.error = res.response.data.message;
        },
        onTableLoadSuccess() {
            this.showRestrictionsStub();
        },
        onForDaySet(data, refresh) {
            this.appendParams.forDay = data;
            if (refresh) {
                let self = this;
                nextTick(() => self.$refs.vuetable.refresh());
            }
        },
        /**
         * Состоит ли фильтр только из обязательного условия.
         * Такой фильтр ограниченному пользователю разрешён (api/Middleware/LinksDemoFilters.php),
         * а без него отчёт отвечает 400, поэтому резать его нельзя
         */
        isRequiredOnlyFilter(filterText) {
            if (!this.requiredFilter) {
                return false;
            }

            return FilterHelper.hasOnlyField(filterText, FilterHelper.fieldName(this.requiredFilter));
        },
        onFilterSet(filterText, refresh) {
            if (this.isRestrictions && !this.isRequiredOnlyFilter(filterText)) {
                this.$emitter.emit(this.dialogRestrictionsListenerId);

                // Фильтр целиком не пропускаем, но обязательное условие вернуть обязаны:
                // без него API отвечает 400 и отчёт не отрисуется вовсе
                if (this.requiredFilter) {
                    this.appendParams.filter = this.requiredFilter;

                    if (refresh) {
                        let self = this;
                        nextTick(() => self.$refs.vuetable.refresh());
                    }
                }

                return false;
            }

            if (!this.isPost && !this.isGetUrlLengthAllowed(filterText)) {
                this.alertError(this.$t('lang.main.table.filter_url_too_long'));
                return false;
            }

            this.appendParams.filter = filterText;

            if (refresh) {
                let self = this;
                nextTick(() => self.$refs.vuetable.refresh());
            }
        },
        onFilterReset() {
            this.deleteParams()
            let self = this;
            nextTick(() => self.$refs.vuetable.refresh())
        },
        deleteParams() {
            delete this.appendParams.filter;
        },
        onRowClass(dataItem, index) {
            let cls = [];
            if (this.isRestrictions && index >= this.demoLimit) {
                cls.push("ks-row-restrictions");
            }

            if (this.domainUrl === undefined && this.domainId !== undefined && this.domainId && dataItem.hasOwnProperty("id") && this.domainId.split(",").indexOf("" + dataItem.id) !== -1) {
                cls.push("ks-row-domain-in-group");
            }

            if (dataItem.hasOwnProperty("master_key") && dataItem.master_key === 1) {
                cls.push("ks-row-master-key");
            }

            return cls.join(" ");
        },
        onContextMenu(row, field, event) {
            if (!this.enabledContextMenu) {
                return false;
            }
            let fieldConfig = clone(this.fields.filter(f => {
                return f.name === field.name;
            })[0]);

            if (fieldConfig && fieldConfig.hasOwnProperty('useInFilter') && fieldConfig.useInFilter) {
                if (fieldConfig.hasOwnProperty('sortField')) {
                    fieldConfig.name = fieldConfig.sortField;
                } else {
                    let fieldSplit = fieldConfig.name.split(':');
                    if (fieldSplit.length > 1) {
                        fieldConfig.name = fieldSplit[1];
                    }
                }

                event.preventDefault();
                this.contextCell = {
                    value: row[fieldConfig.name],
                    fieldConfig: fieldConfig,
                    event: event,
                    row: row
                }
            }
        },
        onCheckboxToggled(row, field, event) {
            this.selectedTo = this.$refs.vuetable.selectedTo;
        },

        showRestrictionsStub() {
            let self = this;

            nextTick(() => {
                setTimeout(function () {
                    if (self.isRestrictions) {
                        let elRows = document.getElementsByClassName("ks-row-restrictions");

                        if (elRows && elRows.length >= 3) {
                            self.$emitter.emit(self.dialogRestrictionsListenerId);
                        }
                    }
                }, 100);
            });
        },
        clearSelectedTo() {
            this.$refs.vuetable.selectedTo = [];
            this.selectedTo = this.$refs.vuetable.selectedTo;
        },
        refresh() {
            let self = this;
            nextTick(function () {
                self.$refs.vuetable.refresh();
            })
        },
        download(additionalParams) {
            let params = this.$refs.vuetable.getAppendParams(this.$refs.vuetable.getAllQueryParams()),
                parts = [];
            let clearPostData = false

            if (this.isPost && !this.localPostData) {
                this.localPostData = JSON.stringify(params) || params;
                clearPostData = true
            } else {
                for (let prop in params) {
                    parts.push(this.encode(prop) + '=' + this.encode(params[prop]));
                }
            }

            parts.push(this.encode("type") + '=' + this.encode("csv"));
            parts.push(this.encode("locale") + '=' + this.encode(this.locale));

            if (additionalParams && Array.isArray(additionalParams)) {
                additionalParams.forEach(p => {
                    parts.push(p);
                })
            }

            let exportCsvUrl = this.getApiUrl;

            if (!_.isUndefined(this.exportCsvUrl) && !_.isNull(this.exportCsvUrl)) {
                exportCsvUrl = this.getApiExportUrl;
            }

            let fullUrl = new URL(exportCsvUrl, this.$config.ROOT_URL);
            let url = exportCsvUrl + (fullUrl.search ? '&' : '?') + parts.join('&');

            let self = this;

            if (this.demoTariffModal.show) {
                this.demoTariffModal.message = this.$t('lang.modal.csvDemoTariff', {limit: this.demoLimit})
                this.$emitter.emit(this.dialogDemoTariffListenerId);
            }

            if (this.useAsyncCsvExport) {
                // Для async/batch запускаем запрос на создание задачи и передаем
                // обработку результата в page-level компонент через событие.
                this.requestCsvExport(url, clearPostData);
                return;
            }

            self.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);

            if (this.isPost && this.localPostData) {
                axios({
                    method: 'post',
                    url: url,
                    withCredentials: true,
                    data: {
                        data: JSON.parse(this.localPostData) || this.localPostData
                    }
                })
                    .then((response) => {
                        self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);

                        if (clearPostData) {
                            this.localPostData = null;
                        }

                        window.open(response.data.location);
                    })
                    .finally(() => {
                        self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);
                        self.emitCsvFinished();
                    });
            } else {
                window.open(url);
                self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE)
                self.emitCsvFinished();
            }
        },
        async requestCsvExport(url, clearPostData = false) {
            try {
                const axiosParams = {
                    method: (this.isPost ? 'post' : 'get'),
                    url,
                    withCredentials: true,
                };

                if (this.isPost && this.localPostData) {
                    axiosParams.data = {
                        data: JSON.parse(this.localPostData) || this.localPostData
                    };
                }

                const response = await axios(axiosParams);
                let payload = response?.data;
                if (typeof payload === 'string') {
                    try {
                        payload = JSON.parse(payload);
                    } catch (e) {
                        payload = response?.data;
                    }
                }

                this.$emit('csv-export-response', {
                    payload,
                    requestUrl: url,
                });

                // Ручка отдала тело файла, а не JSON: выгрузка синхронная, а флаг не снят.
                // Откатываемся на прежнее поведение — иначе пользователь получит тост вместо файла.
                if (payload === null || typeof payload !== 'object') {
                    this.clearSavedCsvExportJobId();
                    this.emitCsvFinished();

                    if (this.isPost) {
                        this.alertError(this.$t('lang.main.toast.error_title'));
                        return;
                    }

                    window.open(url);
                    return;
                }

                // Синхронная ручка: файл уже готов, ссылка пришла сразу.
                if (payload?.location) {
                    this.clearSavedCsvExportJobId();
                    this.emitCsvFinished();
                    window.location.href = payload.location;
                    return;
                }

                const jobId = payload?.job_id || payload?.jobId;
                if (payload?.status === 'queued' && jobId) {
                    this.saveCsvExportJobId(jobId);
                    this.emitCsvProgress(payload);
                    this.alertInfo(payload?.message || this.$t('lang.main.download_file'));
                    await this.waitForCsvExport(jobId);
                    return;
                }

                this.emitCsvFinished();
                this.alertError(payload?.message || this.$t('lang.main.toast.error_title'));
            } catch (error) {
                this.$emit('csv-export-error', {
                    error,
                    requestUrl: url,
                });
                this.clearSavedCsvExportJobId();
                this.emitCsvFinished();
                this.alertError(error?.response?.data?.message || this.$t('lang.main.toast.error_title'));
            } finally {
                if (clearPostData) {
                    this.localPostData = null;
                }
            }
        },
        downloadImages(additionalParams) {
            if (this.selectedTo.length === 0) {
                return
            }

            let params = this.$refs.vuetable.getAppendParams(this.$refs.vuetable.getAllQueryParams());
            let self = this;

            self.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);

            const api = new Api();
            api.postBlob(this.getApiUrl, {
                ...params,
                action: 'downloadImage',
                ids: this.selectedTo,
                ...(additionalParams ? { additionalParams } : {})
            })
            .then(({blob, filename}) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;

                link.download = filename || 'images.zip';
                link.click();
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error('Download error:', error);
            })
            .finally(() => {
                self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);
            });
        },
        copy(additionalParams) {
            if (this.demoTariffModal.show) {
                this.demoTariffModal.message = this.$t('lang.modal.demoTariffNotAllowed')
                this.$emitter.emit(this.dialogDemoTariffListenerId);
                return;
            }

            let params = this.$refs.vuetable.getAppendParams(this.$refs.vuetable.getAllQueryParams()),
                parts = [], self = this;

            for (let prop in params) {
                parts.push(this.encode(prop) + '=' + this.encode(params[prop]));
            }

            parts.push(this.encode("type") + '=' + this.encode("copy"));

            if (additionalParams && Array.isArray(additionalParams)) {
                additionalParams.forEach(p => {
                    parts.push(p);
                })
            }

            let copyUrl = this.getApiUrl;

            if (!_.isUndefined(this.copyUrl) && !_.isNull(this.copyUrl)) {
                copyUrl = this.getApiCopyUrl;
            }

            let fullUrl = new URL(copyUrl, this.$config.ROOT_URL);
            let url = copyUrl + (fullUrl.search ? '&' : '?') + parts.join('&');

            self.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);

            let axiosParams = {
                method: (this.isPost ? 'post' : 'get'),
                url: url,
                withCredentials: true
            };

            if (this.isPost && this.localPostData) {
                axiosParams.data = {
                    data: JSON.parse(this.localPostData) || this.localPostData
                };
            }

            axios(axiosParams)
                .then((response) => {
                    self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);

                    self.$snotify.info(self.$t('lang.main.copy_to_clipboard_btn'), {
                        timeout: 0,
                        showProgressBar: false,
                        buttons: [{
                            text: self.$t('lang.main.btn.copy'), action: (toast) => {
                                self.$snotify.remove(toast.id);
                                clipboard.writeText(response.data);

                            }, bold: true
                        }, {text: self.$t('lang.main.btn.close'), action: null, bold: false},]

                    });

                })
                .finally(() => self.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE));
        },
        domainHistoryByKeyword(data) {
            this.$emitter.emit(Listeners.KS_TABLE_DOMAIN_HISTORY_BY_KEYS, data);
        },
        // Хэш фильтра для ссылки в другой отчёт
        filterHash(filter) {
            return '#filter=' + FilterHelper.encode(filter);
        },
        encode(val) {
            return encodeURIComponent(val)
                .replace(/%40/gi, '@')
                .replace(/%3A/gi, ':')
                .replace(/%24/g, '$')
                .replace(/%2C/gi, FilterConstants.FILTER_ARRAY_DELIMITER)
                .replace(/%20/g, '+')
                .replace(/%5B/gi, '[')
                .replace(/%5D/gi, ']');
        },
        number(value) {
            return `<span class="nobr">${value.formatMoney(0, ' ', ' ')}</span>`;
        },
        humanNumber(value) {
            if (value >= 1000000000) {
                return (value / 1000000000).toFixed(1).toString().replace  (".", ",") +  this.$t('lang.main.table.human_number_format_billion');
            } else if (value >= 1000000) {
                return (value / 1000000).toFixed(1).toString().replace(".", ",") + this.$t('lang.main.table.human_number_format_million');
            } else if (value >= 1000) {
                return (value / 1000).toFixed(1).toString().replace(".", ",") + this.$t('lang.main.table.human_number_format_thousands');
            } else {
                return value.toString();
            }
        },
        string(value) {
            return HtmlHelper.escape(value);
        },
        competition(value) {
            return `<span class="nobr">${this.$t('lang.main.table.competition.' + value)}</span>`;
        },
        numberExt(value) {
            return value !== 0 ? `<span class="nobr">${value.formatMoney(0, ' ', ' ')}</span>` : "";
        },
        float(value) {
            return `<span class="nobr">${value.formatMoney(2, '.', ' ')}</nobr>`;
        },
        zenDatePublishAt(value) {
            return moment(get(value, 'date')).format('DD.MM.YY');
        },
        zenLinkChannel(value) {
            value = HtmlHelper.escape(value);
            return `<span class="nobr"><a href="/${this.locale}/dzen/report?domain=${value}&db=zen" target="_blank">${value}</a></nobr>`;
        },
        percent(value) {
            return `<span class="nobr">${value.formatMoney(2, '.', ' ')} %</span>`;
        },
        currency(value) {
            return value.formatMoney(0, '.', ' ') + ' ' + window.report_db.currency.sign;
        },
        boolean(value) {
            return value ? this.$t('lang.main.yes') : '&mdash;';
        },
        array(value) {
            return value.map(item => HtmlHelper.escape(item)).join(", ");
        },
        arraySemicolon(value) {
            return value.map(item => HtmlHelper.escape(item)).join("; ");
        },
        domain(value) {
            value = HtmlHelper.escape(value);
            return `<span class="nobr"><a href="https://${value}" target="_blank" class="elink" title="${this.$t('lang.main.table.open_page')}"></a><a href="/${this.locale}/report?domain=${value}" title="${this.$t('lang.main.table.open_dashboard')}">${value}</a></span>`;
        },
        domainNotFound(value) {
            value = HtmlHelper.escape(value);
            return `<nobr><a href="https://${value}" target="_blank" class="elink" title="${this.$t('lang.main.table.open_page')}"></a><span>${value}</span></nobr>`;
        },
        cutUrlByDomain(url, domain) {
            let cutUrl = (url.split(domain))[1];
            if (cutUrl !== "") {
                return cutUrl
            }
            return url;
        },
        getDomainReportTitle(domainName) {
            if (!domainName) return '';
            return this.$t('lang.report.dashboard.block_ai_concs.label_report', [domainName]);
        },
        getDomainPageTitle(domainName) {
            if (!domainName) return '';
            return this.$t('lang.report.dashboard.block_ai_concs.label_page', [domainName]);
        },
        onClickDomainPage(domainName) {
            if (domainName) {
                window.open('//' + domainName);
            }
        },
        getDomainReportUrl(domainName) {
            if (!domainName) return '#';
            return '/' + this.locale + '/report?domain=' + domainName + (this.getBaseFromUrl() ? '&db=' + this.getBaseFromUrl() : '');
        },
        keyWord(value) {
            value = HtmlHelper.escape(value);
            return `<span class="nobr"><a href="/${this.locale}/report?domain=${value}" title="${this.$t('lang.main.table.open_keyword')}">${value}</a></span>`;
        },
        similarKeyWord(value) {
            value = HtmlHelper.escape(value);
            return `<span class="nobr"><a href="/${this.locale}/similarkeys?key=${value}" target="_blank" class="esimilar" title="${this.$t('lang.main.table.find_keywords', [value])}"></a><a href="/${this.locale}/report?domain=${value}" target="_blank" class="ekeydashboard" title="${this.$t('lang.main.table.dashboard_keyword', [value])}"></a>${value}</span>`;
        },

        keywordDashboard(value) {
            value = HtmlHelper.escape(value);
            return `<a href="/${this.locale}/report?domain=${value}" target="_blank" class="ekeydashboard" title="${this.$t('lang.main.table.dashboard_keyword', [value])}"></a>${value}`;
        },
        byAdsense(id) {
            return id === "0" ? "&mdash;" : '<a href="/' + this.locale + '/owner/byadsense?id=' + id + '">' + id + '</a>';
        },
        byLeadia(id) {
            return id === 0 ? "&mdash;" : '<a href="/' + this.locale + '/owner/byleadia?id=' + id + '">' + id + '</a>';
        },
        byAnalytics(id) {
            return id === 0 ? "&mdash;" : '<a href="/' + this.locale + '/owner/byanalytics?id=' + id + '">' + id + '</a>';
        },
        byRelapio(id) {
            return id === "0" ? "&mdash;" : '<a href="/' + this.locale + '/owner/byrelapio?id=' + id + '">' + id + '</a>';
        },
        sr(value) {
            if (this.isGoogleNY()) {
                return value === 0 ? `<span title="${this.$t('lang.main.table.sr2_full')}">${this.$t('lang.main.table.sr2')}</span>` : `<span title="${this.$t('lang.main.table.sr3_full')}">${this.$t('lang.main.table.sr3')}</span>`;
            }

            return value === 0 ? `<span title="${this.$t('lang.main.table.sr0_full')}">${this.$t('lang.main.table.sr0')}</span>` : `<span title="${this.$t('lang.main.table.sr1_full')}">${this.$t('lang.main.table.sr1')}</span>`;
        },
        linkType(value) {
            return `<span title="${this.$t('lang.report.backlinks.linkTypes.' + value)}">${this.$t('lang.report.backlinks.linkTypes.' + value)}</span>`
        },
        linkStatus(value) {
            return `<span title="${this.$t('lang.report.backlinks.linkStatus.' + value)}">${this.$t('lang.report.backlinks.linkStatus.' + value)}</span>`
        },
        linkStatuses(value) {
            let statuses = this.$tm('lang.report.backlinks.linkStatus')
            let linkStatuses = value.map(x => statuses[x]).join(', ');
            return `<span title="${linkStatuses}">${linkStatuses}</span>`
        },
        linkRelType(value) {
            let types = this.$tm('lang.report.backlinks.relTypes')
            let realTypes = value.map(x => types[x]).join(', ');
            return `<span title="${realTypes}">${realTypes}</span>`
        },
        zenCommentWrap(value) {
            return parseInt(value) >= Zen.COMMENT_LIMIT ? this.$t('lang.main.zen.zenCommentWrap') : HtmlHelper.escape(value);
        },
        state(value) {
            switch (value) {
                case 10:
                    return this.$tm('lang.main.table.state')[0];
                case 2:
                    return this.$tm('lang.main.table.state')[2];
                default:
                    return this.$tm('lang.main.table.state')[1];
            }
        },
        base(value) {
            return this.$tm('lang.main.bases').filter(item => item.name === value)[0].caption;
        },
        shortDate: value => {
            return value !== "0000-00-00 00:00:00" ? new Date(value).toLocaleString(window.locale, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            }) : "&mdash;";
        },
        fullDate: value => {
            return value !== "0000-00-00 00:00:00" ? new Date(value).toLocaleString(window.locale, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }) : "&mdash;";
        },
        systemNotificationsDate: value => {
            return moment(value).format('DD.MM.YYYY, HH:mm');
        },
        shouldShowExpandButton(aiAnswer) {
            if (!aiAnswer) {
                return false;
            }

            const plainTextLength = aiAnswer.replace(/<[^>]*>/g, '').trim().length;
            const breaksCount = (aiAnswer.match(/<br\s*\/?>/gi) || []).length;
            const listItemsCount = (aiAnswer.match(/<li/gi) || []).length;
            const paragraphCount = (aiAnswer.match(/<p/gi) || []).length;

            return plainTextLength > 200
                || breaksCount >= 2
                || listItemsCount >= 2
                || paragraphCount >= 2;
        },
        toggleAiAnswer(rowData) {
            rowData._aiAnswerExpanded = !rowData._aiAnswerExpanded;
        },
        getPageUrl(fullLink) {
            const url = new URL(fullLink);
            return encodeURIComponent(url.pathname + url.search);
        },
        getBaseFromUrl() {
            if (!this.apiUrl) {
                return null;
            }
            try {
                const url = new URL(this.apiUrl, this.$config.ROOT_URL || window.location.origin);
                return url.searchParams.get('base');
            } catch (e) {
                // Если не удалось распарсить URL, пробуем извлечь параметр base вручную
                const match = this.apiUrl.match(/[?&]base=([^&]+)/);
                return match ? match[1] : null;
            }
        },
        // Ссылка из ячейки пакетного анализа по ссылкам в отчёт по этой строке. Строка режима URL несёт domain,
        // paths — варианты пути страницы, как их склеивает пакет (фильтр path / source_path в отчётах по ссылкам),
        // page_url и page_hash — страницу в органике. db — регион пакета: без него отчёт откроется в регионе из cookie
        linksBatchHref(rowData, column) {
            const isPage = Array.isArray(rowData.paths);
            const base = this.getBaseFromUrl();
            const report = (name, params = '') => '/' + this.locale + '/' + name
                + '?domain=' + encodeURIComponent(isPage ? rowData.domain : rowData.name) + params
                + (base ? '&db=' + base : '');
            // status=1 для backlinks и outlinks — прямо в ссылке, иначе страница отчёта допишет его сама.
            // Без фильтров (демо-режим тарифа ниже нужного) отчёты по ссылкам фильтр отклоняют — ведём на весь домен
            const pageFilter = (field, prefix = '') => isPage && this.isFilter
                ? this.filterHash(prefix + field + 'ONE OF' + rowData.paths.join(FilterConstants.FILTER_ARRAY_DELIMITER))
                : '';

            switch (column) {
                case 'numip':
                    return report('backlinks-ip') + pageFilter('path');
                case 'numurl':
                    return report('backlinks') + pageFilter('path', 'status=1^');
                case 'numdomain':
                    return report('backlinks-domains') + pageFilter('path');
                case 'numoutdomain':
                    return report('outlinks-domains') + pageFilter('source_path');
                case 'numlink':
                    return report('outlinks') + pageFilter('source_path', 'status=1^');
                case 'it10':
                case 'it50': {
                    const top10 = column === 'it10' ? this.filterHash('posBETWEEN1@10') : '';
                    if (!isPage) {
                        return report('keywords') + top10;
                    }

                    return report('keysbypage', '&page_url=' + encodeURIComponent(rowData.page_url)
                        + (rowData.page_hash ? '&hash=' + rowData.page_hash : '')) + top10;
                }
            }
        },
        // Условия по странице (path / source_path) из текущего фильтра отчёта — для ссылок из строки в отчёт по тому же
        // сайту: без них переход из отчёта, открытого по странице (ссылки из пакетного анализа), покажет весь домен.
        // Фильтр раскодируется как на бэкенде (urldecode в Parser::parse), к хэшу добавляется через ^ в кодировке
        // FilterHelper.encode, как в filterHash
        pageFilterHash() {
            let filter;
            try {
                filter = decodeURIComponent(String(this.appendParams.filter || '').replace(/\+/g, ' '));
            } catch (e) {
                return '';
            }

            const conditions = filter.split('^').filter(condition => /^(source_)?path(?![a-z_])/.test(condition));

            return conditions.length ? FilterHelper.encode('^' + conditions.join('^')) : '';
        },
        // месяц помесячного архива рекламы, на который смотрит таблица
        getMonthFromUrl() {
            return new URL(this.apiUrl, window.location.origin).searchParams.get('month') || '';
        },
        // фразы объявления: месяц — тот же, что у таблицы; base — база региона строки, если строки из разных регионов
        adKeysByAdsUrl(domain, ad, base = '') {
            return '/' + this.locale + '/adkeysbyads?domain=' + domain + '&ad=' + ad + this.archiveLinkParams(base);
        },
        // объявления домена — тот же месяц и база региона строки
        adsUrl(domain, base = '') {
            return '/' + this.locale + '/ads?domain=' + domain + this.archiveLinkParams(base);
        },
        archiveLinkParams(base) {
            const month = this.getMonthFromUrl();

            return (month ? '&month=' + month : '') + (base ? '&db=' + base : '');
        },
        getAiAnswersDateFilter() {
            if (this.isDemo) {
                return '';
            }
            const today = moment().format('YYYY-MM-DD');
            const thirtyDaysAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');
            return `#filter=created_atBETWEEN${thirtyDaysAgo}%40${today}`;
        },
        onOpenBdg(e, id) {
            if (this.$refs['overlayBdg' + id].isOpen) {
                this.$refs['overlayBdg' + id].hide();
                return;
            }
            this.$refs['overlayBdg' + id].show(e);
        },
        onOpenOnlineWs(word, graphData) {
            this.$emitter.emit(Listeners.KS_TABLE_POPUP_ONLINE_PARSER_WS, {
                word: word,
                chartData: graphData
            });
        },
        onOpenCpc(e, id) {
            if (this.$refs['overlayCpc' + id].isOpen) {
                this.$refs['overlayCpc' + id].hide();
                return;
            }
            this.$refs['overlayCpc' + id].show(e);
        },
        onClickBuyTariff() {
            window.open(sprintf('/%s/tarif', window.locale));
        },
        onClickRestrictionButton() {
            return !this.isAuthorized
                ? window.open(sprintf('/%s/register', window.locale))
                : (
                    this.isPayed
                        ? window.open(sprintf('/%s/subscription?needleTariff=%s', window.locale, this.needleTariff))
                        : window.open(sprintf('/%s/tarif', window.locale)
                )
            );
        },
        getTopMenuHeight() {
            // Основной источник оффсета: переменная, которую обновляет верхнее меню.
            const cssTopMenuHeight = parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue('--keysso-top-menu-height')
            );
            if (Number.isFinite(cssTopMenuHeight) && cssTopMenuHeight > 0) {
                return Math.max(0, Math.ceil(cssTopMenuHeight) - 1);
            }

            const menuEl = document.querySelector('.menu_top__container_left, .menu_top__container, .menu_top_lite');
            const menuRect = menuEl?.getBoundingClientRect();
            const rawBottom = menuRect?.bottom || menuRect?.height || 60;
            return Math.max(0, Math.ceil(rawBottom) - 1);
        },
        scheduleFrozenHeadSync() {
            if (!this.frozenHead || this.frozenHeadRafId) {
                return;
            }

            // Один пересчет на кадр, чтобы не дергать DOM слишком часто.
            this.frozenHeadRafId = requestAnimationFrame(() => {
                this.frozenHeadRafId = null;
                this.syncFrozenHeadPosition();
            });
        },
        resetFrozenHeadStyles() {
            this.isFrozenHeadActive = false;
            if (this.$refs.frozenHeadOverlay) {
                this.$refs.frozenHeadOverlay.innerHTML = '';
            }
        },
        getTableWrapperEl() {
            return this.$el?.querySelector('.tablewrap') || null;
        },
        getTableEl() {
            return this.getTableWrapperEl()?.querySelector('table.vuetable') || null;
        },
        getTheadEl() {
            return this.getTableEl()?.querySelector('thead') || null;
        },
        syncFrozenHeadCellWidths(sourceTheadEl, cloneTheadEl) {
            // Клон шапки обязан иметь ту же ширину колонок, что и "живая" таблица.
            const sourceThEls = Array.from(sourceTheadEl.querySelectorAll('th'));
            const cloneThEls = Array.from(cloneTheadEl.querySelectorAll('th'));
            const count = Math.min(sourceThEls.length, cloneThEls.length);

            for (let i = 0; i < count; i += 1) {
                const width = sourceThEls[i].getBoundingClientRect().width || sourceThEls[i].offsetWidth || 0;
                if (!width) {
                    continue;
                }
                cloneThEls[i].style.width = `${width}px`;
                cloneThEls[i].style.minWidth = `${width}px`;
                cloneThEls[i].style.maxWidth = `${width}px`;
            }
        },
        syncFrozenHeadOverlayContent(tableEl, theadEl) {
            const overlayEl = this.$refs.frozenHeadOverlay;
            if (!overlayEl) {
                return null;
            }

            // Рендерим в overlay отдельную таблицу с копией thead,
            // не трогая исходный thead в основном потоке.
            const tableClassName = tableEl.getAttribute('class') || 'vuetable';
            const nextHtml = `<table class="${tableClassName}"><thead>${theadEl.innerHTML}</thead></table>`;
            if (overlayEl.innerHTML !== nextHtml) {
                overlayEl.innerHTML = nextHtml;
            }

            return overlayEl.querySelector('thead');
        },
        onFrozenHeadOverlayClick(event) {
            const overlayEl = this.$refs.frozenHeadOverlay;
            if (!overlayEl || !this.isFrozenHeadActive) {
                return;
            }

            const overlayTh = event.target.closest('th');
            if (!overlayTh) {
                return;
            }

            const overlayThEls = Array.from(overlayEl.querySelectorAll('th'));
            const targetIndex = overlayThEls.indexOf(overlayTh);
            if (targetIndex < 0) {
                return;
            }

            const sourceThEls = Array.from(this.getTheadEl()?.querySelectorAll('th') || []);
            const sourceTh = sourceThEls[targetIndex];
            if (!sourceTh) {
                return;
            }

            const sourceCheckbox = sourceTh.querySelector('input[type="checkbox"]');
            if (sourceCheckbox) {
                // Для колонки чекбоксов повторяем нативное поведение переключения.
                sourceCheckbox.click();
                return;
            }

            // Для sortable-колонок пробрасываем клик в исходный th.
            sourceTh.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            }));
        },
        syncFrozenHeadPosition() {
            const tableEl = this.getTableEl();
            const theadEl = this.getTheadEl();
            const wrapperEl = this.getTableWrapperEl();
            if (!tableEl || !theadEl || !wrapperEl) {
                return;
            }

            const menuHeight = this.getTopMenuHeight();
            const wrapperRect = wrapperEl.getBoundingClientRect();
            const theadRect = theadEl.getBoundingClientRect();
            const headHeight = theadEl.offsetHeight || theadRect.height;
            const activationTop = menuHeight - this.frozenHeadActivationThreshold;
            const deactivationTop = menuHeight + this.frozenHeadActivationThreshold;
            const canFreezeByBottom = wrapperRect.bottom > menuHeight + headHeight;
            const shouldFreeze = this.isFrozenHeadActive
                ? wrapperRect.top <= deactivationTop && canFreezeByBottom
                : theadRect.top <= activationTop && canFreezeByBottom;

            if (!shouldFreeze) {
                this.resetFrozenHeadStyles();
                return;
            }

            this.isFrozenHeadActive = true;
            const overlayEl = this.$refs.frozenHeadOverlay;
            if (!overlayEl) {
                return;
            }
            const overlayTheadEl = this.syncFrozenHeadOverlayContent(tableEl, theadEl);
            if (!overlayTheadEl) {
                return;
            }

            this.syncFrozenHeadCellWidths(theadEl, overlayTheadEl);

            const scrollLeft = wrapperEl.scrollLeft;
            const tableWidth = tableEl.getBoundingClientRect().width;
            // Overlay живет в viewport-координатах, поэтому позиционируем его явно.
            overlayEl.style.top = `${menuHeight}px`;
            overlayEl.style.left = `${wrapperRect.left}px`;
            overlayEl.style.width = `${wrapperRect.width}px`;

            const overlayTableEl = overlayEl.querySelector('table');
            if (overlayTableEl) {
                overlayTableEl.style.width = `${tableWidth}px`;
                overlayTableEl.style.transform = `translateX(${-scrollLeft}px)`;
            }
        },
    },
    watch: {
        selectedTo(val) {
            this.$emitter.emit(Listeners.KS_TABLE_CHECKBOX_SELECTED, val);
        }
    },
}
</script>
<template>
    <div class="ks-vuetable-container" :class="{'ks-vuetable-container__frozen_head': frozenHead}">
        <template v-if="loading">
            <div id="ks-preloader-table">
                <div id="ks-loader"></div>
            </div>
        </template>

        <div v-if="message" class="ks-alert alert alert-info">
            <i aria-hidden="true" class="fa fa-info-circle"></i>&nbsp
            <span v-text="message"></span>
        </div>
        <div v-if="messageCollapse" class="ks-alert alert alert-info">
            <i aria-hidden="true" class="fa fa-info-circle"></i>&nbsp
            <span v-html="messageCollapse.title"></span>
            <span class="ks-alert-collapse__link" @click="showMessageCollapse = !showMessageCollapse">
                {{ showMessageCollapse ? $t('lang.main.table.message_collapse.hide') : $t('lang.main.table.message_collapse.show') }}
            </span>
            <div v-show="showMessageCollapse" class="ks-alert-collapse__text_container" v-html="messageCollapse.text"></div>
        </div>
        <div v-if="error" class="ks-table-error"><i aria-hidden="true" class="fa fa-exclamation"></i>&nbsp;<span
            v-html="error"></span></div>

        <div class="flex justify-content-between align-items-center">
            <div class="pagination-row pagination-row-top flex justify-content-between align-items-center flex-grow-1" v-if="showPaginationTop" v-show="showPagination">
                <ks-pagination
                    ref="paginationTop"
                    :on-each-side="2"
                    :simple-pagination="simplePagination"
                    @vuetable-pagination:change-page="onChangePage"></ks-pagination>

                <ks-pagination-info ref="paginationInfoTop" :css="css.paginationInfo" :info-template="infoTemplate"
                                    :no-data-template="noDataTemplate"></ks-pagination-info>
            </div>
            <slot name="before_table"></slot>
        </div>

        <div class="tablewrap">
            <vuetable ref="vuetable"
                      :api-url="getApiUrl"
                      :multi-sort="true"
                      :sort-order="sortOrder"
                      :per-page="tPerPage"
                      :initial-page="tInitialPage"
                      :fields="getFields"
                      :css="css.table"
                      :append-params="appendParams"
                      :no-data-template="noDataTemplate"
                      :http-options="{ withCredentials: true, headers: {'Accept-Language': locale}}"
                      :http-method="isPost ? 'post' : 'get'"
                      :row-class="onRowClass"
                      :post-data="getDataForPost"
                      pagination-path=""
                      @vuetable:initialized="onTableInitialized"
                      @vuetable:loading="onTableLoading"
                      @vuetable:loaded="onTableLoaded"
                      @vuetable:load-error="onTableLoadError"
                      @vuetable:load-success="onTableLoadSuccess"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:cell-rightclicked="onContextMenu"
                      @vuetable:row-clicked="onRowClicked"
                      @vuetable:checkbox-toggled="onCheckboxToggled"
                      @vuetable:checkbox-toggled-all="onCheckboxToggled"
            >


                <template v-if="isAllRsyAds" v-slot:custom="tableData">
                    <tr>
                        <td :colspan="fields.length" style="padding: 0">
                            <all-rsy-ads-container :table-data="tableData.tableData"></all-rsy-ads-container>
                        </td>
                    </tr>
                </template>

                <template #word="props">
                    <span v-html="keywordDashboard(props.rowData.word)"></span>
                </template>

                <template #rsy_ad_img="props">
                    <rsy-ad-img-container :files="props.rowData.files" :ad-id="props.rowData.id" :child-count="props.rowData.group ? props.rowData.group.length : 0"/>
                </template>

                <template #rsy_ad="props">
                    <ks-rsy-ad
                        :title="props.rowData.title"
                        :second-title="props.rowData.second_title"
                        :body="props.rowData.body"
                        :company-name="props.rowData.company_name"
                        :ad-url="props.rowData.url"
                    />
                </template>

                <template #url="props">
                    <div class="ks-row-page">
                        <a :href="'https://' + domainUrl + props.rowData.url" :title="$t('lang.main.table.open_page')"
                           class="elink"
                           style="margin-right: 5px;" target="_blank"></a>
                        <a :href="'/' + locale + '/concurentpages?domain=' + domainUrl + '&page_url=' + encodeURIComponent(props.rowData.url)"
                           :title="$t('lang.main.table.concurent_page', [domainUrl + props.rowData.url])" class="esimilar"
                           target="_blank"></a>
                        <a :href="'/' + locale + '/keysbypage?domain=' + domainUrl + '&page_url=' + encodeURIComponent(props.rowData.url)"
                           :title="$t('lang.main.table.keys_by_page', [domainUrl + props.rowData.url])">{{
                                props.rowData.url
                            }}</a>
                        <div v-if="props.rowData.churl" v-tooltip="$t('lang.main.table.change_page_url')"
                             class=""
                             style="float:right; background: url(/i/sprites.webp?v=3) -580px -100px no-repeat; width: 11px; height: 10px; margin: 0px 5px 0 0px;"></div>
                    </div>
                </template>

                <template #site_url="props">
                    <div class="flex">
                        <div class="ks-row-page">
                            <a :href="'https://' + domainUrl + props.rowData.url" :title="$t('lang.main.table.open_page')"
                                class="elink"
                                style="margin-right: 5px;" target="_blank"></a>
                            <a :href="'/' + locale + '/concurentpages?domain=' + domainUrl + '&page_url=' + encodeURIComponent(props.rowData.url)"
                                :title="$t('lang.main.table.concurent_page', [domainUrl + props.rowData.url])" class="esimilar"
                                target="_blank"></a>
                            <a :href="'/' + locale + '/keysbypage?domain=' + domainUrl + '&page_url=' + encodeURIComponent(props.rowData.url) + '&hash=' + props.rowData.hash"
                                :title="$t('lang.main.table.keys_by_page', [domainUrl + props.rowData.url])">{{
                                props.rowData.url }}</a>
                            <div v-if="props.rowData.churl" v-tooltip="$t('lang.main.table.change_page_url')"
                                class=""
                                style="float:right; background: url(/i/sprites.webp?v=3) -580px -100px no-repeat; width: 11px; height: 10px; margin: 0px 5px 0 0px;"></div>
                        </div>
                        <div>
                            <sup class="pos_sup" v-if="props.rowData.new_url" >
                                <span class="positive">new</span>
                            </sup>
                        </div>
                    </div>
                </template>

                <template #lost_url="props">
                    <div class="ks-row-page">
                        <a :href="'https://' + domainUrl + props.rowData.url" :title="$t('lang.main.table.open_page')"
                           class="elink"
                           style="margin-right: 5px;" target="_blank"></a>
                        <a :href="'/' + locale + '/keysbylostpage?domain=' + domainUrl + '&page_url=' + encodeURIComponent(props.rowData.url)"
                           :title="$t('lang.main.table.keys_by_lostpage', [domainUrl + props.rowData.url])">{{
                                props.rowData.url
                            }}</a>
                    </div>
                </template>

                <template #zen_report_publication_title="props">
                    <div class="ks-row-page">
                        <a :href="get(props, 'rowData.url')"
                           rel="noopener"
                           target="_blank"
                           :title="get(props, 'rowData.title')"
                           style="margin-right: 5px;">
                            {{ get(props, 'rowData.title') }}
                        </a>
                    </div>
                </template>

                <template #zen_report_concurrent_title="props">
                    <div class="ks-row-page">
                        <a :href="get(props, 'rowData.url')"
                           class="elink"
                           target="_blank">
                        </a>
                        <a
                            :href="'/' + locale + '/dzen/report?channel=' + get(props, 'rowData.id')"
                            :title="get(props, 'rowData.name')"
                            rel="noopener"
                            style="margin-right: 5px;"
                            target="_blank"
                        >
                            {{ get(props, 'rowData.name') }}
                        </a>
                    </div>
                </template>

                <template #url_group="props">
                    <div class="ks-row-page">
                        <a :href="'https://' + props.rowData.domain + props.rowData.url" target="_blank" class="elink"
                           :title="$t('lang.main.table.open_page')"></a>
                        {{ props.rowData.url }}
                    </div>
                </template>

                <template #url_pages_concurent="props">
                    <div class="ks-row-page-concurent">
                        <a :href="'https://' + props.rowData.domain + props.rowData.url"
                           :title="$t('lang.main.table.open_page')" class="elink"
                           style="margin-right: 5px;" target="_blank"></a>
                        <a :href="'/' + locale + '/concurentpages?domain=' + props.rowData.domain + '&page_url=' + encodeURIComponent(props.rowData.url)"
                           :title="$t('lang.main.table.concurent_page', [props.rowData.domain + props.rowData.url])"
                           class="esimilar"
                           target="_blank"></a>
                        <a :href="'/' + locale + '/keysbypage?domain=' + props.rowData.domain + '&page_url=' + encodeURIComponent(props.rowData.url)"
                           :title="$t('lang.main.table.keys_by_page', [props.rowData.domain + props.rowData.url])">{{
                                props.rowData.url
                            }}</a>
                    </div>
                </template>

                <template #keyscnt="props">
                    <a :href="adKeysByAdsUrl(domainUrl, props.rowData.id)"
                       :title="$t('lang.main.table.adkeys_by_ads')"
                       target="_blank"><span v-html="number(props.rowData.keyscnt)"></span></a>
                </template>

                <template #keys_count="props">
                    <a :href="`/${locale}/yandex-direct-archive/adkeys?domain=${props.rowData.domain}&adTitle=${props.rowData.title}&uuid=${props.rowData.uuid}`"
                       :title="$t('lang.main.table.adkeys_by_ads')"
                       target="_blank"><span v-html="number(props.rowData.keys_count)"></span></a>
                </template>

                <template #ads_count="props">
                    <a :href="`/${locale}/yandex-direct-archive/ads?kid=${props.rowData.id}`"
                       :title="$t('lang.main.table.ads_by_key')"
                       target="_blank"><span v-text="props.rowData.ads_count"></span></a>
                </template>

                <template #domain="props">
                    <a :href="`/${locale}/yandex-direct-archive/domain?domain=${props.rowData.domain}`"
                       :title="$t('lang.main.table.adkeys_by_ads')"><span v-text="props.rowData.domain"></span></a>
                </template>

                <template #ads_domain="props">
                    <a v-if="props.rowData.domain" :href="adsUrl(props.rowData.domain, props.rowData.base)"
                       target="_blank">{{ props.rowData.domain }}</a>
                </template>

                <template #keyscnt_group="props">
                    <a :href="adKeysByAdsUrl(props.rowData.domain, props.rowData.aid, props.rowData.base)"
                       :title="$t('lang.main.table.adkeys_by_ads')" target="_blank"><span
                        v-html="number(props.rowData.keyscnt)"></span></a>
                </template>

                <template #adkeys_header="props">
                    <a :href="adKeysByAdsUrl(domainUrl, props.rowData.aid)"
                       :title="$t('lang.main.table.adkeys_by_ads_header', [props.rowData.header])"
                       target="_blank">{{ props.rowData.header }}</a>
                </template>

                <template #keys_meta="props">
                <span v-if="props.rowData.isgeo" v-tooltip.left="$t('lang.main.table.is_geo')"><i
                    aria-hidden="true" class="fa fa-globe ks-icons"></i></span>
                    <span v-if="props.rowData.isquest" v-tooltip.left="$t('lang.main.table.is_quest')"><i
                        aria-hidden="true" class="fa fa-question-circle-o ks-icons"></i></span>
                </template>

                <template #cluster_ws="props">
                    <span v-html="props.rowData.ws !== '—' ? number(props.rowData.ws) : '—'"></span>
                </template>

                <template #cluster_wsk="props">
                    <span v-html="props.rowData.wsk !== '—' ? number(props.rowData.wsk) : '—'"></span>
                </template>

                <template #cluster_superwsk="props">
                    <span v-html="props.rowData.superwsk !== '—' ? number(props.rowData.superwsk) : '—'"></span>
                </template>

                <template #it10="props">
                    <a :href="'/' + locale + '/keywords?domain=' + props.rowData.name + '#filter=posBETWEEN1%254010'" target="_blank"
                       @contextmenu="onContextMenu(props.rowData, {name: '__slot:it10'}, $event)"><span
                        v-html="number(props.rowData.it10)"></span></a>
                </template>

                <template #it50="props">
                    <a :href="'/' + locale + '/keywords?domain=' + props.rowData.name" target="_blank"
                       @contextmenu="onContextMenu(props.rowData, {name: '__slot:it50'}, $event)"><span
                        v-html="number(props.rowData.it50)"></span></a>
                </template>

                <template #aianswerscnt="props">
                    <div style="display: flex; align-items: center; gap: 8px; justify-content: flex-end;">
                        <a :href="'/' + locale + '/ai-answers?domain=' + props.rowData.name + (getBaseFromUrl() ? '&db=' + getBaseFromUrl() : '') + getAiAnswersDateFilter()"
                           target="_blank"
                           @contextmenu="onContextMenu(props.rowData, {name: '__slot:aianswerscnt'}, $event)">
                            <span v-html="number(props.rowData.aianswerscnt)"></span>
                        </a>

                        <!-- Показываем статус только для CREATED (0), STARTED (1) и ERROR (2) -->
                        <!-- Для READY (10) ничего не показываем -->
                        <span v-if="props.rowData.ai_state !== null && props.rowData.ai_state !== undefined && props.rowData.ai_state !== 10" style="display: inline-flex; align-items: center;">
                            <!-- CREATED (0) - лоадер без анимации -->
                            <i v-if="props.rowData.ai_state === 0"
                               class="pi pi-sync text-color-secondary text-sm"
                               style="font-size: 0.7rem;"
                               v-tooltip.top="$t('lang.tools.domains_batch.ai_state.created')"></i>
                            <!-- STARTED (1) - лоадер с анимацией (крутится) -->
                            <i v-else-if="props.rowData.ai_state === 1"
                               class="pi pi-spin pi-sync text-color-secondary text-sm"
                               style="font-size: 0.7rem;"
                               v-tooltip.top="$t('lang.tools.domains_batch.ai_state.building')"></i>
                            <!-- ERROR (2) - оставляем как есть -->
                            <i v-else-if="props.rowData.ai_state === 2"
                               class="pi pi-exclamation-triangle text-red-500 text-sm"
                               style="font-size: 0.7rem;"
                               v-tooltip.top="$t('lang.tools.domains_batch.ai_state.error')"></i>
                        </span>
                    </div>
                </template>

                <template #group="props">
                    <a :href="'/' + locale + '/group/' + props.rowData.rid + '?db=' + props.rowData.base"
                       :title="$t('lang.main.table.open_report')"><span v-text="props.rowData.name"></span></a>
                </template>

                <template #cluster="props">
                    <a :href="'/' + locale + '/clustering-list/' + props.rowData.uid + '?db=' + props.rowData.base"
                       :title="$t('lang.main.table.edit_project')"><span v-text="props.rowData.name"></span></a>
                </template>

                <template #ads_url="props">
                    <div class="ks-row-page-ads" @contextmenu="onContextMenu(props.rowData, {name: '__slot:ads_url'}, $event)">
                        <a :href="props.rowData.url" :title="props.rowData.url" ><span
                            v-text="props.rowData.url"></span></a>
                    </div>
                </template>

                <template #link="props">
                    <div class="ks-row-page-ads">
                        <a :href="props.rowData.link" :title="props.rowData.link" target="_blank"><span
                            v-text="props.rowData.link"></span></a>
                    </div>
                </template>

                <template #links_source_url="props">
                    <div class="ks-row-page-200">
                        <a :href="props.rowData.source_url" :title="props.rowData.source_url" target="_blank"><span
                            v-text="cutUrlByDomain(props.rowData.source_url, props.rowData.source_name)"></span></a>
                    </div>
                </template>

                <template #links_source_name="props">
                    <div class="ks-row-page-200">
                        <span v-if="props.rowData.domain_exist" v-html="domain(props.rowData.source_name)"></span>
                        <span v-else v-html="domainNotFound(props.rowData.source_name)"></span>
                    </div>
                </template>

                <template #links_target_name="props">
                    <div class="ks-row-page-200">
                        <span v-if="props.rowData.domain_exist" v-html="domain(props.rowData.name)"></span>
                        <span v-else v-html="domainNotFound(props.rowData.name)"></span>
                    </div>
                </template>

                <template #links_target_url="props">
                    <div class="ks-row-page-200">
                        <a :href="props.rowData.url" :title="props.rowData.url" target="_blank"><span
                            v-text="cutUrlByDomain(props.rowData.url, props.rowData.name)"></span></a>
                    </div>
                </template>

                <template #links_url="props">
                    <div class="ks-row-page-200">
                        <a :href="props.rowData.url" :title="props.rowData.url" target="_blank"><span
                            v-text="props.rowData.url"></span></a>
                    </div>
                </template>

                <template #links_anchor="props">
                    <div class="ks-row-page-200">
                        <span :title="props.rowData.anchor" v-text="props.rowData.anchor"></span>
                    </div>
                </template>

                <template #links_numurl="props">
                    <a :href="'/' + locale + '/backlinks?domain=' + props.rowData.name" target="_blank" v-html="number(props.rowData.numurl)" />
                </template>

                <template #links_numlink="props">
                    <a :href="'/' + locale + '/outlinks?domain=' + props.rowData.name" target="_blank" v-html="number(props.rowData.numlink)" />
                </template>

                <template #links_batch_numurl="props">
                    <a :href="linksBatchHref(props.rowData, 'numurl')" target="_blank" v-html="number(props.rowData.numurl)"
                       @contextmenu="onContextMenu(props.rowData, {name: '__slot:links_batch_numurl'}, $event)" />
                </template>

                <template #links_batch_numlink="props">
                    <a :href="linksBatchHref(props.rowData, 'numlink')" target="_blank" v-html="number(props.rowData.numlink)"
                       @contextmenu="onContextMenu(props.rowData, {name: '__slot:links_batch_numlink'}, $event)" />
                </template>

                <template #links_batch_it10="props">
                    <a :href="linksBatchHref(props.rowData, 'it10')" target="_blank"
                       @contextmenu="onContextMenu(props.rowData, {name: '__slot:links_batch_it10'}, $event)"><span
                        v-html="number(props.rowData.it10)"></span></a>
                </template>

                <template #links_batch_it50="props">
                    <a :href="linksBatchHref(props.rowData, 'it50')" target="_blank"
                       @contextmenu="onContextMenu(props.rowData, {name: '__slot:links_batch_it50'}, $event)"><span
                        v-html="number(props.rowData.it50)"></span></a>
                </template>

                <template #links_batch_page_vis="props">
                    <span v-html="number(props.rowData.vis)"></span>
                </template>

                <template #name="props">
                    <div class="flex align-items-center gap-2">
                        <i
                            class="pi pi-link text-color-secondary text-sm cursor-pointer"
                            :title="getDomainPageTitle(props.rowData.name)"
                            @click="onClickDomainPage(props.rowData.name)"
                        ></i>
                        <a
                            :href="getDomainReportUrl(props.rowData.name)"
                            :title="getDomainReportTitle(props.rowData.name)"
                            target="_blank"
                        >
                            {{ props.rowData.name }}
                        </a>
                    </div>
                </template>

                <template #queries_in_ai_answers="props">
                    <a
                        :href="'/' + locale + '/ai-answers?domain=' + props.rowData.name + (getBaseFromUrl() ? '&db=' + getBaseFromUrl() : '') + getAiAnswersDateFilter()"
                        :title="$t('lang.report.dashboard.block_ai_concs.label_ai_answers_report', [props.rowData.name])"
                        target="_blank"
                        v-html="number(props.rowData.queries_in_ai_answers)"
                    />
                </template>

                <template #perc="props">
                    <span>{{ FormatHelper.number(props.rowData.perc, '', true) }}%</span>
                </template>

                <template #theme="props">
                    <span>{{ FormatHelper.number(props.rowData.theme, '', true) }}%</span>
                </template>

                <template #pos="props">
                    <span @contextmenu="onContextMenu(props.rowData, {name: '__slot:pos'}, $event)" class="flex gap-1 justify-content-end">
                        <template v-if="props.rowData.nw">{{ props.rowData.pos }}</template>
                        <a v-if="!props.rowData.nw" :title="$t('lang.main.table.pos_history')" href
                           @click.prevent="domainHistoryByKeyword(props.rowData)">{{ props.rowData.pos }}</a>
                        <sup class="position_sup">
                            <span v-if="props.rowData.nw" class="positive">new</span><span
                            v-if="!props.rowData.nw && props.rowData.delta > 0"
                            class="positive">+{{ props.rowData.delta }}</span><span
                            v-if="!props.rowData.nw && props.rowData.delta < 0"
                            class="negative">{{ props.rowData.delta }}</span><span
                            v-if="!props.rowData.nw && props.rowData.delta == 0">&nbsp;</span>
                        </sup>
                    </span>
                </template>

                <template #numip="props">
                    <a :href="linksBatchHref(props.rowData, 'numip')" target="_blank" v-html="number(props.rowData.numip)"
                       @contextmenu="onContextMenu(props.rowData, {name: '__slot:numip'}, $event)" />
                </template>

                <template #system_notifications__title="props">
                    <div class="system_notifications__title">
                        <a
                            v-if="!!props.rowData.link && props.rowData.link.length > 0"
                            :href="props.rowData.link"
                            target="_blank"
                        >
                            <span>{{ props.rowData.title }}</span>
                            <img src="/i/icons/outer-link.svg" alt="">
                        </a>
                        <span v-else>{{ props.rowData.title }}</span>
                    </div>
                </template>

                <template #backlinks_toppages_numurl="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks?domain=' + domainUrl + filterHash('url=' + props.rowData.url)"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ props.rowData.numurl }}
                        </a>
                    </div>
                </template>
                <template #backlinks_toppages_url="props">
                    <div class="ks-row-page">
                        <a :href="props.rowData.url" :title="$t('lang.main.table.open_page')" class="elink" style="margin-right: 5px;" target="_blank"></a>
                        <a
                            :href="'/' + locale + '/concurentpages?domain=' + domainUrl + '&page_url=' + getPageUrl(props.rowData.url)"
                            :title="$t('lang.main.table.concurent_page', [props.rowData.url])"
                            class="esimilar"
                            target="_blank"
                        ></a>
                        <a
                            :href="'/' + locale + '/keysbypage?domain=' + domainUrl + '&page_url=' + getPageUrl(props.rowData.url)"
                            :title="$t('lang.main.table.keys_by_page', [props.rowData.url])"
                        >
                            {{ props.rowData.url }}
                        </a>
                    </div>
                </template>

                <template #backlinks_domain="props">
                    <div class="ks-row-page-200">
                        <span v-html="domain(props.rowData.name)"></span>
                    </div>
                </template>

                <template #backlinks_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        {{ humanNumber(props.rowData.backlinks_count) }}
                    </div>
                </template>

                <template #backlinks_active_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/outlinks?domain=' + domainUrl + filterHash('name=' + props.rowData.name + '^status=1') + pageFilterHash()"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.backlinks_active_count) }}
                        </a>
                    </div>
                </template>

                <template #backlinks_archive_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/outlinks?domain=' + domainUrl + filterHash('name=' + props.rowData.name + '^status=10') + pageFilterHash()"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.backlinks_archive_count) }}
                        </a>
                    </div>
                </template>

                <template #outlinks_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        {{ humanNumber(props.rowData.outlinks_count) }}
                    </div>
                </template>

                <template #outlinks_active_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks?domain=' + domainUrl + filterHash('source_name=' + props.rowData.name + '^status=1') + pageFilterHash()"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.outlinks_active_count) }}
                        </a>
                    </div>
                </template>

                <template #outlinks_archive_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks?domain=' + domainUrl + filterHash('source_name=' + props.rowData.name + '^status=10') + pageFilterHash()"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.outlinks_archive_count) }}
                        </a>
                    </div>
                </template>

                <template #ips="props">
                     <div class="ks-row-page" style="text-align: right;">
                        <ul>
                            <li v-for="ip in props.rowData.ips">
                                <span v-text="ip"></span>
                            </li>
                        </ul>
                    </div>
                </template>

                <template #total_backdomains_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks-domains?domain=' + props.rowData.name"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.total_backdomains_count) }}
                        </a>
                    </div>
                </template>

                <template #numdomain="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="linksBatchHref(props.rowData, 'numdomain')"
                           @contextmenu="onContextMenu(props.rowData, {name: '__slot:numdomain'}, $event)"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.numdomain) }}
                        </a>
                    </div>
                </template>

                <template #numoutdomain="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="linksBatchHref(props.rowData, 'numoutdomain')"
                           @contextmenu="onContextMenu(props.rowData, {name: '__slot:numoutdomain'}, $event)"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.numoutdomain) }}
                        </a>
                    </div>
                </template>

                <template #backlinks_count_for_anchor="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks?domain=' + domainUrl + filterHash('anchor=' + props.rowData.anchor + '^link_type=' + props.rowData.link_type)"
                           rel="noopener"
                           target="_blank"
                        >
                            {{ humanNumber(props.rowData.backlinks_count) }}
                        </a>
                    </div>
                </template>

                <template #total_outdomains_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/outlinks-domains?domain=' + props.rowData.name"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.total_outdomains_count) }}
                        </a>
                    </div>
                </template>

                <template #total_backips_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks-ip?domain=' + props.rowData.name"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.total_backips_count) }}
                        </a>
                    </div>
                </template>

                <template #ai_answer="props">
                    <div class="ks-row-ai-answer">
                        <template v-if="props.rowData.ai_answer">
                            <div
                                class="ai-answer-content"
                                :class="{
                                    expanded: props.rowData._aiAnswerExpanded,
                                    collapsed: !props.rowData._aiAnswerExpanded
                                }"
                            >
                                <div class="ai-answer-html" v-html="props.rowData.ai_answer"></div>
                            </div>
                            <button
                                v-if="shouldShowExpandButton(props.rowData.ai_answer)"
                                @click="toggleAiAnswer(props.rowData)"
                                class="ai-answer-toggle"
                                type="button"
                            >
                                <i :class="['pi', props.rowData._aiAnswerExpanded ? 'pi-chevron-up' : 'pi-chevron-down']"></i>
                                <span>
                                    {{
                                        props.rowData._aiAnswerExpanded
                                            ? $t('lang.main.btn.close')
                                            : $t('lang.main.btn.expand_alt')
                                    }}
                                </span>
                            </button>
                        </template>
                        <div v-else class="ai-answer-empty">
                            {{ $t('lang.report.aiAnswers.ai_answer_empty') }}
                        </div>
                    </div>
                </template>

                <template #backdomains_ip_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks-domains?domain=' + domainUrl + filterHash('source_ip=' + props.rowData.source_ip) + pageFilterHash()"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.domains_count) }}
                        </a>
                    </div>
                </template>

                <template #backlinks_ip_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks?domain=' + domainUrl + filterHash('source_ip=' + props.rowData.source_ip + '^status=1') + pageFilterHash()"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.backlinks_count) }}
                        </a>
                    </div>
                </template>

                <template #backdomains_subnet_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks-domains?domain=' + domainUrl + filterHash('source_ip=' + props.rowData.subnet)"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.domains_count) }}
                        </a>
                    </div>
                </template>

                <template #backlinks_subnet_count="props">
                    <div class="ks-row-page" style="text-align: right;">
                        <a :href="'/' + locale + '/backlinks?domain=' + domainUrl + filterHash('source_ip=' + props.rowData.subnet)"
                           rel="noopener"
                           target="_blank"
                           style="margin-right: 5px;">
                            {{ humanNumber(props.rowData.backlinks_count) }}
                        </a>
                    </div>
                </template>

                <template #wordstat_word="props">
                    <div class="ks-row-page">
                        <div class="flex align-items-center justify-content-between" style="gap: 13px;">
                            <div class="flex align-items-center">
                                <Popper hover :content="props.rowData.word">
                                    <span class="nobr" style="max-width: 300px;display: inline-block;text-overflow: ellipsis;overflow: hidden;">{{ props.rowData.word }}</span>
                                </Popper>
                            </div>
                            <Popper
                                v-if="props.rowData.reason"
                                placement="auto"
                                hover
                                arrow
                                style="line-height: 1; padding: 1px;"
                            >
                                <template #content>
                                    <span style="white-space: normal;">{{ props.rowData.reason }}</span>
                                </template>
                                <i class="pi pi-exclamation-circle text-orange-400" style="font-size: 13px"></i>
                            </Popper>
                        </div>
                    </div>
                </template>

                <template #wordstat_ws="{rowData}">
                    <a v-if="rowData.wsGraph.length" class="nobr kstable__wordstat_cpc_bdg_link cursor-pointer" @click.prevent="() => onOpenOnlineWs(rowData.word ,rowData.wsGraph)">{{ FormatHelper.number(rowData.ws) }}</a>
                    <span v-else class="nobr">{{ FormatHelper.nullableNumber(rowData.ws) }}</span>
                </template>
                <template #wordstat_qwsk="{rowData}">
                    <span class="nobr">{{ FormatHelper.nullableNumber(rowData.qwsk) }}</span>
                </template>
                <template #wordstat_wsk="{rowData}">
                    <span class="nobr">{{ FormatHelper.nullableNumber(rowData.wsk) }}</span>
                </template>
                <template #wordstat_swsk="{rowData}">
                    <span class="nobr">{{ FormatHelper.nullableNumber(rowData.swsk) }}</span>
                </template>
                <template #rsya="{rowData}">
                    <div class="flex justify-content-end">
                        <a
                            v-if="rowData.rsya"
                            :href="'/' + locale + '/rsya/ads?domain=' + rowData.name" target="_blank"
                        >
                            <span class="nobr" >{{ FormatHelper.numberWithZero(rowData.rsya) }}</span>
                        </a>
                        <span class="nobr" v-else>{{ FormatHelper.numberWithZero(rowData.rsya) }}</span>
                    </div>
                </template>

                <template #wordstat_cpc="{rowData}">
                    <div class="flex justify-content-end">
                        <a href="#" class="kstable__wordstat_cpc_bdg_link" @click.prevent="(e) => onOpenCpc(e, rowData.id)">
                            {{ rowData.cpc100.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}
                        </a>
                    </div>
                    <AdaptersOverlayPanel
                        class="item tooltip-target"
                        placement="right-start"
                        :ref="'overlayCpc' + rowData.id"
                        :pt="{
                            root: {class: 'kstable__wordstat_cpc_bdg_overlay'}
                        }"
                    >
                        <div>
                            <table class="kstable__wordstat_cpc_bdg">
                                <thead>
                                    <tr>
                                        <th>{{ $t('lang.wordstat.report.th_traffic') }}</th>
                                        <th>{{ $t('lang.wordstat.report.th_cpc') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>100%</td>
                                        <td>{{ rowData.cpc100.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                    </tr>
                                    <tr>
                                        <td>85%</td>
                                        <td>{{ rowData.cpc85.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                    </tr>
                                    <tr>
                                        <td>62%</td>
                                        <td>{{ rowData.cpc62.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                    </tr>
                                    <tr>
                                        <td>9%</td>
                                        <td>{{ rowData.cpc9.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                    </tr>
                                    <tr>
                                        <td>5%</td>
                                        <td>{{ rowData.cpc5.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="kstable__wordstat_cpc_bdg_instruction">
                                <a href="//help.keys.so/faq#hfaq-post-1932">{{ $t('lang.wordstat.report.link_info') }} <i class="pi pi-info-circle"></i></a>
                            </div>
                        </div>
                    </AdaptersOverlayPanel>
                </template>
                <template #keyword_budget="{rowData}">
                    <div class="flex justify-content-end">
                        <ReportKeywordBudget :budget="rowData.bdg100" :budgets="rowData.budgets" />
                    </div>
                </template>
                <template #wordstat_bdg="{rowData}">
                    <div class="flex justify-content-end">
                        <a href="#" class="kstable__wordstat_cpc_bdg_link" @click.prevent="(e) => onOpenBdg(e, rowData.id)">
                            {{ rowData.bdg100.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}
                        </a>
                    </div>
                    <AdaptersOverlayPanel
                        class="item tooltip-target"
                        placement="right-start"
                        :ref="'overlayBdg' + rowData.id"
                        :pt="{
                            root: {class: 'kstable__wordstat_cpc_bdg_overlay'}
                        }"
                    >
                        <div>
                            <table class="kstable__wordstat_cpc_bdg">
                                <thead>
                                <tr>
                                    <th>{{ $t('lang.wordstat.report.th_traffic') }}</th>
                                    <th>{{ $t('lang.wordstat.report.th_bdg') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>100%</td>
                                    <td>{{ rowData.bdg100.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                </tr>
                                <tr>
                                    <td>85%</td>
                                    <td>{{ rowData.bdg85.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                </tr>
                                <tr>
                                    <td>62%</td>
                                    <td>{{ rowData.bdg62.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                </tr>
                                <tr>
                                    <td>9%</td>
                                    <td>{{ rowData.bdg9.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                </tr>
                                <tr>
                                    <td>5%</td>
                                    <td>{{ rowData.bdg5.formatMoney(2, ',', ' ') }} {{ $t('lang.main.currency.sign') }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="kstable__wordstat_cpc_bdg_instruction">
                                <a href="//help.keys.so/faq#hfaq-post-1934">{{ $t('lang.wordstat.report.link_info') }} <i class="pi pi-info-circle"></i></a>
                            </div>
                        </div>
                    </AdaptersOverlayPanel>
                </template>
            </vuetable>
        </div>

        <div class="pagination-row" v-show="showPagination">
            <ks-pagination
                ref="pagination"
                :on-each-side="2"
                :simple-pagination="simplePagination"
                @vuetable-pagination:change-page="onChangePage"></ks-pagination>

            <ks-pagination-info ref="paginationInfo" :css="css.paginationInfo" :info-template="infoTemplate"
                                :no-data-template="noDataTemplate"></ks-pagination-info>
        </div>

        <has-another-results :total="this.total" :limit="this.demoLimit" v-if="isRestrictions && !showPagination"></has-another-results>

        <cell-context-filter :cell="contextCell"/>

        <AdaptersDialog
            :listener-id="dialogRestrictionsListenerId"
            :header="$t('lang.modal.notification')"
            :button-agree-label="getRestrictionDialogAgreeButtonTitle"
            :callback-agree="onClickRestrictionButton"
        >
            <template #content>
                <div class="grid">
                    <div class="col">
                        <p v-if="!isAuthorized">{{ $t('lang.promo_tariff.rst_msg_register') }}</p>
                        <template v-else-if="isDemo">
                            <p class="flex flex-column">
                                <span>{{ $t('lang.promo_tariff.rst_msg') }}</span>
                                <span v-if="!isPayed" v-html="$t('backend.notification.select_promo_tariff')"></span>
                            </p>
                        </template>
                        <p v-else>{{ $t('lang.promo_tariff.rst_msg_subscribe') }}</p>
                    </div>
                </div>
            </template>
        </AdaptersDialog>

        <AdaptersDialog
            :listener-id="dialogDemoTariffListenerId"
            :header="$t('lang.modal.notification')"
            :button-agree-label="$t('lang.modal.buy_tariff')"
            :callback-agree="onClickBuyTariff"
        >
            <template #content>
                <div class="modal-notification" v-html="demoTariffModal.message"></div>
            </template>
        </AdaptersDialog>

        <domain-history-by-keywords />

        <div
            v-if="frozenHead"
            v-show="isFrozenHeadActive"
            ref="frozenHeadOverlay"
            class="ks-vuetable-container__frozen_head_overlay"
            @click="onFrozenHeadOverlayClick"
        ></div>
    </div>


</template>
<style>

.ks-row-restrictions {
    background-repeat: no-repeat;
    -webkit-filter: blur(3px);
    -moz-filter: blur(3px);
    filter: blur(3px);
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.ks-row-restrictions > a, .ks-row-restrictions > td {
    pointer-events: none;
    cursor: default;
}

.ks-row-page {
    max-width: 600px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ks-row-page-concurent {
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ks-row-page-ads{
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ks-row-page-200{
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ks-table-error {
    color: #e32;
    font-size: 12px;
}

.vuetable-th-checkbox-id {
    width: 15px;
}

.ks-row-domain-in-group {
    background-color: #dee2e6 !important;
}

.ks-row-master-key {
    background-color: rgb(217, 234, 211) !important;
}

.ks-vuetable-container {
    position: relative;
}

.ks-restrictions-stub {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url(/i/key.webp) 50% 50% no-repeat;
    background-size: 140px;
    left: 0;
    right: 0;
}

.ks-restrictions-stub .filter {
    width: 100%;
    padding: 10px;
    background: rgba(255, 255, 255, .5);
    border-radius: 5px;
}

.ks-restrictions-stub p {
    line-height: 20px;
    font-weight: 400;
    font-size: 15px;
    margin: 0 24px 0 12px;
    text-align: center;
}

.ks-restrictions-stub a {
    padding-top: 10px;
}

.pos_sup {
    margin-top: -10px;
    vertical-align: super;
    font-size: smaller;
    width: 20px;
    font-size: 9px;
    display: inline-block;
}

.pos_sup .positive {
    color: #1ABB9C;
}

.pos_sup .negative {
    color: #E74E3F;
}

.ks-row-ai-answer {
    max-width: 500px;
    word-wrap: break-word;
}

.ai-answer-content {
    position: relative;
}

.ai-answer-content.collapsed {
    max-height: 140px;
    overflow: hidden;
}

.ai-answer-content.collapsed::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 36px;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    pointer-events: none;
}

.ai-answer-content.expanded {
    max-height: none;
}

.ai-answer-html {
    white-space: normal;
}

.ai-answer-html ul {
    list-style: none;
    padding-left: 0;
}

.ai-answer-toggle {
    margin-top: 8px;
    padding: 4px 0;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    color: #195481;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.ai-answer-toggle i {
    color: #195481;
}

.ai-answer-toggle:hover {
    color: #195481;
}

.ai-answer-toggle:hover i {
    color: #195481;
}

.ai-answer-link {
    display: inline-flex;
    align-items: center;
    color: #4f9ad1;
    background-color: #F0F4F7;
    padding: 2px 8px;
    border-radius: 50px;
    margin-right: 6px;
    margin-bottom: 6px;
}

.ai-answer-link i {
    font-size: 11px;
    padding: 2px;
}

.ai-answer-link a {
    margin-left: 2px;
}

.ai-answer-sources {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
}

.ai-answer-empty {
    color: #999;
    font-style: italic;
}


</style>

<style scoped>
.ks-alert-collapse__link {
    cursor: pointer;
    text-decoration: underline;
}
.ks-alert-collapse__text_container {
    max-height: 145px;
    overflow-y: auto;
    margin-top: 5px;
}

.system_notifications__title a,
.system_notifications__title a:hover {
    text-decoration: none;
    color: #232D35;
}
.system_notifications__title a span {
    transition: all .3s;
    margin-right: 5px;
    text-decoration: underline;
    text-decoration-color: transparent;
}
.system_notifications__title a:hover span {
    color: #0B69F5;
    text-decoration-color: #0B69F5;
    /*add those for opera and mozilla support*/
    -webkit-text-decoration-color: #0B69F5;
    -moz-text-decoration-color: #0B69F5;
}
.position_sup {
    min-width: 20px;
    font-size: 9px;
    display: inline-block;
    line-height: 1;
    text-align: left;
}
.position_sup .positive {
    color: #1ABB9C;
}
.position_sup .negative {
    color: #E74E3F;
}

.ks-vuetable-container__frozen_head .tablewrap {
    overflow-y: visible;
}

.ks-vuetable-container__frozen_head_overlay {
    position: fixed;
    z-index: 1002;
    overflow: hidden;
    pointer-events: auto;
}

.ks-vuetable-container__frozen_head_overlay :deep(table) {
    table-layout: fixed;
}

.ks-vuetable-container__frozen_head_overlay :deep(thead th) {
    background: var(--surface-card, #fff);
    pointer-events: auto;
}
</style>
